export enum ConfirmationPageEntityType {
  GET_TICKLET = "GET_TICKLET",
  BUY_BULK_TICKETS = "BUY_BULK_TICKETS",
  BUY_HOSTED_MEETINGS = "BUY_HOSTED_MEETINGS",
  TICKET_CHANGE = "TICKET_CHANGE"
}

export const InventoryPurchaseTypes = [
  ConfirmationPageEntityType.BUY_BULK_TICKETS,
  ConfirmationPageEntityType.BUY_HOSTED_MEETINGS
];

export const TicketPurchaseTypes = [ConfirmationPageEntityType.GET_TICKLET, ConfirmationPageEntityType.TICKET_CHANGE];
